exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".baseloadercont .sk-loader-child {\n  width: 100%;\n  max-width: inherit !important;\n}\n.sk-base-image-solid {\n  width: 100%;\n  background-color: #efefef;\n  padding-bottom: 100%;\n}\n.sk-base-title-solid {\n  background: #efefef;\n  width: 100%;\n  height: 20px;\n  margin-bottom: 1rem;\n}\n.sk-base-cont-solid {\n  width: 100%;\n  background: #efefef;\n  height: 20px;\n}\n.sk-base-specscont-solid {\n  width: 100%;\n  background: #efefef;\n  height: 14px;\n  margin-bottom: 1rem;\n}\n.sk-base-btn-solid {\n  width: 100px;\n  background: #efefef;\n  height: 45px;\n  border-radius: 3px;\n}", ""]);

// exports
